import React from 'react';

const CalendarSvg: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="2rem"
      height="1.75rem"
      viewBox="0 0 80 70"
    >
      <g id="ic_calendar" transform="translate(-815 -1078)">
        <g id="Group_207" data-name="Group 207">
          <g id="Group_206" data-name="Group 206">
            <g
              id="Rectangle_31"
              data-name="Rectangle 31"
              transform="translate(829 1106)"
              fill="none"
              stroke="#505050"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="3"
            >
              <rect width="16" height="12" stroke="none" />
              <rect x="1.5" y="1.5" width="13" height="9" fill="none" />
            </g>
            <g
              id="Rectangle_171"
              data-name="Rectangle 171"
              transform="translate(829 1121)"
              fill="none"
              stroke="#505050"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="3"
            >
              <rect width="16" height="12" stroke="none" />
              <rect x="1.5" y="1.5" width="13" height="9" fill="none" />
            </g>
            <g
              id="Rectangle_167"
              data-name="Rectangle 167"
              transform="translate(848 1106)"
              fill="none"
              stroke="#505050"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="3"
            >
              <rect width="15" height="12" stroke="none" />
              <rect x="1.5" y="1.5" width="12" height="9" fill="none" />
            </g>
            <g
              id="Rectangle_170"
              data-name="Rectangle 170"
              transform="translate(848 1121)"
              fill="none"
              stroke="#505050"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="3"
            >
              <rect width="15" height="12" stroke="none" />
              <rect x="1.5" y="1.5" width="12" height="9" fill="none" />
            </g>
            <g
              id="Rectangle_168"
              data-name="Rectangle 168"
              transform="translate(866 1106)"
              fill="none"
              stroke="#505050"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="3"
            >
              <rect width="16" height="12" stroke="none" />
              <rect x="1.5" y="1.5" width="13" height="9" fill="none" />
            </g>
            <g
              id="Rectangle_169"
              data-name="Rectangle 169"
              transform="translate(866 1121)"
              fill="none"
              stroke="#505050"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="3"
            >
              <rect width="16" height="12" stroke="none" />
              <rect x="1.5" y="1.5" width="13" height="9" fill="none" />
            </g>
          </g>
          <g
            id="Rectangle_166"
            data-name="Rectangle 166"
            transform="translate(823 1088.558)"
            fill="none"
            stroke="#505050"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="3"
          >
            <rect width="65" height="51" rx="1" stroke="none" />
            <rect
              x="-1.5"
              y="-1.5"
              width="68"
              height="54"
              rx="2.5"
              fill="none"
            />
          </g>
          <line
            id="Line_23"
            data-name="Line 23"
            y2="7.374"
            transform="translate(836.89 1084)"
            fill="none"
            stroke="#505050"
            strokeLinecap="round"
            strokeWidth="3"
          />
          <line
            id="Line_24"
            data-name="Line 24"
            y2="7.374"
            transform="translate(855.358 1084)"
            fill="none"
            stroke="#505050"
            strokeLinecap="round"
            strokeWidth="3"
          />
          <line
            id="Line_25"
            data-name="Line 25"
            y2="7.374"
            transform="translate(873.827 1084)"
            fill="none"
            stroke="#505050"
            strokeLinecap="round"
            strokeWidth="3"
          />
          <path
            id="Path_54"
            data-name="Path 54"
            d="M-2,0H65.717"
            transform="translate(823.5 1099.567)"
            fill="none"
            stroke="#505050"
            strokeWidth="3"
          />
        </g>
        <rect
          id="Rectangle_396"
          data-name="Rectangle 396"
          width="80"
          height="70"
          transform="translate(815 1078)"
          fill="none"
          opacity="0.327"
        />
      </g>
    </svg>
  );
};
export default CalendarSvg;
